import dashboardLearnAndGrowYourBusiness from './component'
import { commonRenderProps } from '../../common/props'

export default (context: object, container: string) => {
  const props = {
    ...commonRenderProps({ context }),
  }

  dashboardLearnAndGrowYourBusiness(props).render(container)
}
